/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Enquiry} from '../../core/_models'
import {ID, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useLocation, useNavigate} from 'react-router-dom'
import _ from 'lodash'
type Props = {
  enquiry: Enquiry
  id: ID
}

const InfoCell: FC<Props> = ({id, enquiry}) => {
  const navigate = useNavigate()
  const location = useLocation()

  const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
  const openViewPage = () => {
    navigate({
      pathname: `${location.pathname}/eq-detail`,
      search: `?Id=${id}`,
    })
  }
  return (
    <div onClick={openViewPage} className='d-flex align-items-center pointer'>
      <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
        <a>
          <div className='symbol-label'>
            <img src={blankImg} alt={enquiry?.first_name} className='w-100' />
          </div>
        </a>
      </div>
      <div className='d-flex flex-column'>
        <a className='text-gray-800 text-hover-primary mb-1'>
          {enquiry?.first_name} {enquiry?.last_name}
        </a>
        <span>{enquiry?.email}</span>
      </div>
    </div>
  )
}

export {InfoCell}
